import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	modalConfirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalCancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalConfirmButton: {
		id: 'software-board-create.modal.form.actions.modal-confirm-button',
		defaultMessage: 'Create',
		description: 'Text for the modal Confirm Button',
	},
	modalCancelButton: {
		id: 'software-board-create.modal.form.actions.modal-cancel-button',
		defaultMessage: 'Cancel',
		description: 'Text for the modal Cancel button',
	},
});
export default messages;
